import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-date-select-dialog',
  templateUrl: './date-select-dialog.component.html',
  styleUrls: ['./date-select-dialog.component.scss']
})
export class DateSelectDialogComponent implements OnInit {

  instruction: string = "Select date";
  date: string;

  constructor(private _dialogRef: MdDialogRef<DateSelectDialogComponent>) { }

  ngOnInit() {
    let today = new Date();
    this.date = today.toISOString().substr(0,10);
  }

  close(result: {date: string}) {
    this._dialogRef.close(result);
  }

}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/date-select-dialog/date-select-dialog.component.ts